module.exports = __webpack_public_path__ + "fonts/AdelleSAGE-Bold.f8fe6b2d.ttf";